import React, { Component } from "react";
import {Helmet} from 'react-helmet'

class PageHelmet extends Component{
    render(){
        return(
            <React.Fragment>
                <Helmet>
                    <title>{this.props.pageTitle}</title>
                    <meta name="BUSTED" content="Swipe your symptoms, get results, show your health history." />
                </Helmet>
            </React.Fragment>
        )
    }
}


export default PageHelmet;
